import React from 'react';

const NotFoundPage: React.FC = () => {
  return (
    <div>
      404 - Not Found
    </div>
  );
};

export default NotFoundPage;
